"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var eventTrackerHandler = function eventTrackerHandler(url, title, categoryType) {
  _publish.default.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    click_source: 'topic stream',
    category_type: categoryType
  });
};

var TopicBreadcrumb = function TopicBreadcrumb(_ref) {
  var parentCategoryTitle = _ref.parentCategoryTitle,
      parentCategoryUrl = _ref.parentCategoryUrl,
      categoryTitle = _ref.categoryTitle,
      parentCategoryId = _ref.parentCategoryId,
      categoryUrl = _ref.categoryUrl;
  return (0, _preact.h)("span", {
    className: "thread-meta-item thread-meta-item--hover-highlight thread-meta-item--parent-forum qa-topic-meta-in-subforum"
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__text extra-category-level"
  }, (0, _preact.h)("a", {
    className: "thread-meta-item__link",
    onClick: function onClick() {
      return eventTrackerHandler("".concat(parentCategoryUrl), parentCategoryTitle, 'parent category');
    },
    href: (0, _absoluteUrlRuntime.resolveUrl)(parentCategoryUrl)
  }, (0, _preact.h)("span", null, parentCategoryTitle)), (0, _preact.h)("span", null, " / "), (0, _preact.h)("a", {
    className: "thread-meta-item__link",
    onClick: function onClick() {
      return eventTrackerHandler(categoryUrl, categoryTitle, 'category');
    },
    href: (0, _absoluteUrlRuntime.resolveUrl)(categoryUrl)
  }, (0, _preact.h)("span", null, categoryTitle))));
};

var _default = TopicBreadcrumb;
exports.default = _default;